import { Component, OnInit } from '@angular/core';
import {SharedService} from '../shared-service.service';
import {ApiService} from '../api.service';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css']
})
export class RequestComponent implements OnInit {
  lclRequestId: number;
  lclRequestDetail: any = {};
  constructor(private api: ApiService,
              public shared: SharedService) {
    this.shared.gRequestIdObservable().subscribe(
      gRequestId => {
        console.info(gRequestId);
        this.lclRequestId = gRequestId;
        this.invokeServiceForGetRequestDetail(this.lclRequestId);
      }
    );
  }

  ngOnInit() {
  }

  invokeServiceForGetRequestDetail(requestId) {
    this.api.getRequestByIdrequest(requestId).subscribe(res => {
      this.lclRequestDetail = res;
    }, (error) => {
      console.error(error);
    });
  }

}
